import { FC } from 'react';
import { MeetingAssignmentsTable } from './MeetingAssignmentsTable';
import { Modal } from 'react-bootstrap';
import { typeMeeting } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    closeModal: () => void;
    label: string;
    meetings: typeMeeting[];
};

export const MeetingAssignmentsModal: FC<propsType> = ({ closeModal, label, meetings }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <Modal fullscreen show onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    {label}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'p-0 m-0'}>
                <MeetingAssignmentsTable
                    justFuture={false}
                    meetings={meetings}
                />
            </Modal.Body>
        </Modal>
    );
}
